"use strict";

var LoggerInstance = require("js-logger").get("OtherAddressesHelper");

var AccountStore = require("./AccountStore");
var SmartyStreets = require("./SmartyStreets");

var AccountFormHelper = require("../accountComponents/AccountFormHelper");

var ActionsHelper = require("../actions/ActionsHelper");

var AccountApi = require("../api/AccountApi");

var Spinner = require("../client/Spinner");

var SubmitButtonHelper = require("../commonComponents/SubmitButtonHelper");
var ValidationHelper = require("../commonComponents/ValidationHelper");

var Constants = require("../designer/Constants");

var ApiHelper = require("../shared/ApiHelper");
var BootstrapPrompt = require("../shared/BootstrapPrompt");
var HtmlHelper = require("../shared/HtmlHelper");
var LinkMessageHelper = require("../shared/LinkMessageHelper");
var PartialResponseHelper = require("../shared/PartialResponseHelper");

var otherAddressesSingleAddressEditComponentName = "otherAddresses.populated.singleAddress.edit";

var otherAddressesSelector = "[data-component='otherAddresses']";
var addFormSelector = "[data-component='otherAddresses.addForm']";
var singleAddressSelector = "[data-component='otherAddresses.populated.singleAddress']";
var singleAddressViewSelector = "[data-component='otherAddresses.populated.singleAddress.view']";
var populatedAddressWrapperSelector = "div.otherAddresses-items-wrapper";
var otherAddressesAddSmartyStreetsInstance = "otherAddressesAdd";
var otherAddressesEditSmartyStreetsInstance = "otherAddressesEdit";

var OtherAddressesHelper = {
	initialize: function($singleAddress) {
		if ($($singleAddress || "body").find(`${singleAddressViewSelector} input[type='radio'][name='otherAddressesSelector']`)) {
			$($singleAddress || "body").find(singleAddressViewSelector).click((event) => {
				$(event.currentTarget).closest(singleAddressViewSelector).find("input[type='radio'][name='otherAddressesSelector']").prop("checked", true).change();
				//Uncheck Add new Address
				$(event.currentTarget).closest(otherAddressesSelector).find(`${addFormSelector} input[type='radio'][name='otherAddressesSelector']`).prop("checked", false);
			});
		}

		if ($(addFormSelector).find("input[type='radio'][name='otherAddressesSelector']")) {
			$(addFormSelector).click((event) => {
				var $addFormSelector = $(event.currentTarget).closest(addFormSelector).find("input[type='radio'][name='otherAddressesSelector']");
				if ($addFormSelector.prop("checked") !== true) {
					$(event.currentTarget).closest(otherAddressesSelector).find("input[type='radio'][name='otherAddressesSelector']").prop("checked", false).change();
					$addFormSelector.prop("checked", true).change();
				}
			});
		}
	},

	cancelEditOtherAddress: function(event) {
		event = this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper("cancelEditOtherAddress"));
		if (!event) {
			return false;
		}

		var $currentAddress = $(event.target).closest(singleAddressSelector);

		this._getOtherAddressHtml(event, /*isEditing*/false).done(() => {
			SmartyStreets.removeOtherAddressEdit($currentAddress.attr("data-address-id"));
		});

		return false;
	},

	cancelAddOtherAddress: function(event) {
		event = this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper("cancelAddOtherAddress"));
		if (!event) {
			return false;
		}

		//Set the first populated other addresses radio buttons to checked
		$(`${singleAddressViewSelector}`).first().find("input[type='radio'][name='otherAddressesSelector']").prop("checked", true).change();
		//Uncheck the new other address radio button
		$(addFormSelector).find("input[type='radio'][name='otherAddressesSelector']").prop("checked", false);

		this._clearAddEditFieldsAndToggle(/*show*/false);

		return false;
	},

	deleteOtherAddress: function(event) {
		event = this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper("deleteOtherAddress"));
		if (!event) {
			return false;
		}

		BootstrapPrompt.confirm({
			btnCancelLabel: window.BUTTON_LABELS.NO,
			btnOKLabel: window.BUTTON_LABELS.YES,
			message: AccountStore.get("wizardOtherAddressesDisplayMessages").deleteConfirmation
		}, (result) => {
			if (result) {
				Spinner.showSpinner();

				var $currentAddress = $(event.target).closest(singleAddressSelector);
				var addressId = $currentAddress.attr("data-address-id");

				//Call API to delete
				AccountApi.otherAddressDelete(addressId).done(() => {
					//If successful, delete the address
					HtmlHelper.deleteChildOfColumnAndPromoteColumnChildren($currentAddress);
				}).fail((jqXHR, textStatus) => {
					this._resolveError(jqXHR, textStatus);
				}).always(() => Spinner.removeSpinner());
			}
		});

		return false;
	},

	editOtherAddress: function(event) {
		event = this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper("editOtherAddress"));
		if (!event) {
			return false;
		}

		this._getOtherAddressHtml(event, /*isEditing*/true).done(($editAddressForm) => {
			var $addressFormComponent = $editAddressForm.find("form#editOtherAddresses");
			var addressId = $editAddressForm.attr("data-address-id");

			var newAddressFormId = `${$addressFormComponent.attr("id")}-${addressId}`;
			HtmlHelper.setUniqueFormId($addressFormComponent, newAddressFormId);

			SmartyStreets.initializeForOtherAddressesEdit(addressId);
			//Making it so SmartyStreets verify does not run unless the address is changed.
			$addressFormComponent.attr(Constants.ADDRESS_VERIFICATION_STATUSES_ATTRIBUTES.VERIFIED, "true");
		});

		return false;
	},

	addOtherAddress: function(event) {
		event = this._getEventOrReturn(event, "Save Add Other Address called successfully.");
		if (!event) {
			return false;
		}

		var components = [
			$(event.target).closest(addFormSelector)
		];

		Spinner.showSpinner();
		ValidationHelper.validate({ components }).always(isValid => {
			if (!isValid) {
				Spinner.removeSpinner();
				return;
			}

			var $otherAddresses = $(event.target).closest(otherAddressesSelector);
			var otherAddressesComponentId = $otherAddresses.attr("id");

			//Call API to add
			SmartyStreets.verifyAddress(otherAddressesAddSmartyStreetsInstance).done(() => {
				var requestData = AccountFormHelper.serializeAddressForm("form#addOtherAddresses");
				AccountApi.otherAddressAdd(otherAddressesComponentId, requestData).done((data) => {
					var actionData = SubmitButtonHelper.getPostSubmitActionData(addFormSelector);
					var $firstSingleAddress = $otherAddresses.find(`${singleAddressSelector}`).first();
					if (!$firstSingleAddress.length) {
						//If we do not have any otherAddresses, just reload the page
						window.location.reload();
					} else {
						var $data = $(data);

						var numberOfColumns = $otherAddresses.attr("data-columns");
						var $lastRow = $otherAddresses.find(`${singleAddressSelector}`).last().closest("div.row");
						var currentColumns = $lastRow.children("div").length;

						var $newColumn = $(null);
						if (currentColumns < numberOfColumns) {
							//If the last row has space, just clone the column
							$newColumn = $lastRow.children("div").first().clone();
							$lastRow.append($newColumn);
						} else {
							//If there is no space on the last row, we need to clone and create a new row
							$lastRow = $lastRow.clone();
							$lastRow.children(":not(:first-child)").remove();
							$newColumn = $lastRow.children("div").first();
							$otherAddresses.find(populatedAddressWrapperSelector).append($lastRow);
						}

						//Empty last column and fill it with new other address;
						$newColumn.empty().append($data);

						this.initialize($data);
						this._clearAddEditFieldsAndToggle(/*show*/false);
						SubmitButtonHelper.performPostSubmitAction(
							addFormSelector,
							{ actionData }
						);
					}
				}).fail((jqXHR, textStatus) => {
					this._resolveError(jqXHR, textStatus);
				}).always(() => Spinner.removeSpinner());
			}).fail(() => Spinner.removeSpinner());
		});

		return false;
	},

	saveEditOtherAddress: function(event) {
		event = this._getEventOrReturn(event, "Save Edit Other Address called successfully.");
		if (!event) {
			return false;
		}

		var components = [
			$(event.target).closest(`[data-component='${otherAddressesSingleAddressEditComponentName}']`)
		];

		Spinner.showSpinner();
		ValidationHelper.validate({ components }).always(isValid => {
			if (!isValid) {
				Spinner.removeSpinner();
				return;
			}

			var $singleAddress = $(event.target).closest(singleAddressSelector);
			var addressId = $singleAddress.attr("data-address-id");
			var otherAddressesComponentId = $singleAddress.closest(otherAddressesSelector).attr("id");

			//Call API to edit
			SmartyStreets.verifyAddress(`${otherAddressesEditSmartyStreetsInstance}${addressId}`).done(() => {
				var requestData = ActionsHelper.serializeForm("form#editOtherAddresses-" + addressId); //Not calling AccountFormHelper.serializeAddressForm() because we do not want to default the country if not provided.
				AccountFormHelper.setSmartyStreetsFields(requestData, $("form#editOtherAddresses-" + addressId));
				AccountApi.otherAddressEdit(addressId, otherAddressesComponentId, requestData).done((data) => {
					var actionData = SubmitButtonHelper.getPostSubmitActionData(`[data-component='${otherAddressesSingleAddressEditComponentName}']`);
					var $data = $(data);

					$singleAddress.replaceWith($data);
					this.initialize($data);
					HtmlHelper.focusAndSelectFirstField($data);

					SubmitButtonHelper.performPostSubmitAction(
						`[data-component='${otherAddressesSingleAddressEditComponentName}']`,
						{ actionData }
					);

					SmartyStreets.removeOtherAddressEdit(addressId);
				}).fail((jqXHR, textStatus) => {
					this._resolveError(jqXHR, textStatus);
				}).always(() => Spinner.removeSpinner());
			}).fail(() => Spinner.removeSpinner());
		});
	},

	showAddNewOtherAddress: function(event) {
		event = this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper("addNewOtherAddress"));
		if (!event) {
			return false;
		}

		var $addForm = $(addFormSelector);
		var defaultCountry = AccountStore.getDefaultCountry();

		this._clearAddEditFieldsAndToggle(/*show*/true);
		//Making sure it is in view, scrolling to where the to is at half the page if it's below there.
		var newScrollPosition = $("[data-component='otherAddresses.addForm']").offset().top - ($(window).height() / 2);
		if ($(document).scrollTop() < newScrollPosition) {
			$("html, body").animate({scrollTop: newScrollPosition}, 500);
		}

		$addForm.find("[data-component='accountAddressType'] select").prop("disabled", false);
		$addForm.find("[data-component='accountAddressState'] select").prop("disabled", false);
		window.AccountActions.setSelectedCountry($addForm.attr("id"), defaultCountry);

		//Set all the populated other addresses radio buttons to unchecked
		$(singleAddressViewSelector).find("input[type='radio'][name='otherAddressesSelector']").prop("checked", false);
		//Check the new other address radio button
		$(addFormSelector).find("input[type='radio'][name='otherAddressesSelector']").prop("checked", true).change();

		return false;
	},

	_clearAddEditFieldsAndToggle: function(show) {
		var $addEditForm = $(addFormSelector);

		$(`${addFormSelector} input,${addFormSelector} select`).val("");
		window.AccountActions.setSelectedCountry($addEditForm.attr("id"), "");
		window.AccountActions.setSelectedState($addEditForm.attr("id"), "");

		$addEditForm.attr("data-address-id", "");
		$addEditForm.toggle(show);

		if (show) {
			//Uncheck Add/Edit Form
			$addEditForm.find("input[type='radio'][name='otherAddressesSelector']").prop("checked", false);

			//If we are in the context of shipToOtherAddress, we want to hide the submit button.
			if ($("[data-component='shipToOtherAddresses']").length && !$addEditForm.attr("data-address-id")) {
				$addEditForm.find("[data-component='submitButton']").toggle(false);
			}
		} else if ($("[data-component='shipToOtherAddresses']").length) {
			//If we are in the context of the shipToAddress, we want to show the submit button.
			//If we are in the context of shipToOtherAddress, we want to hide the submit button.
			$addEditForm.find("[data-component='submitButton']").toggle(true);
		}

		if (!show) {
			//We need to reset the SmartyStreets Verify
			SmartyStreets.clearVerification("otherAddresses");
		}
	},

	_getEventOrReturn: function (event, isDesignModeMessage) {
		return ActionsHelper.getEventOrReturn(event, AccountStore.get("isDesignMode"), isDesignModeMessage, /*preventDefaultInDesignMode*/false);
	},

	_getOtherAddressHtml: function(event, isEditing) {
		var deferred = new $.Deferred();

		var $currentAddress = $(event.target).closest(singleAddressSelector);

		Spinner.showSpinner($currentAddress);

		var addressId = $currentAddress.attr("data-address-id");
		var otherAddressesComponentId = $currentAddress.closest(otherAddressesSelector).attr("id");

		AccountApi.otherAddressesGet(addressId, otherAddressesComponentId, isEditing).done((data) => {
			var $data = $(data);
			HtmlHelper.addIdToDataComponents($data);

			$currentAddress.replaceWith($data);
			this.initialize($data);
			HtmlHelper.focusAndSelectFirstField($data);

			window.PostalCodeHelper.addCountryChangeListeners($data);

			deferred.resolve($data);
		}).fail((jqXHR, textStatus) => {
			this._resolveError(jqXHR, textStatus, deferred);
		}).always(() => {
			Spinner.removeSpinner($currentAddress);
		});

		return deferred;
	},

	_resolveError(jqXHR, textStatus, deferred) {
		if (!jqXHR || !jqXHR.responseJSON || !PartialResponseHelper.handleErrorResponse(jqXHR.responseJSON)) {
			//There was not a partial error, so do what we normally would do.
			ApiHelper.displayErrorMessage(jqXHR);
		}

		if (deferred) {
			deferred.reject(jqXHR, textStatus);
		}
	},
};

OtherAddressesHelper.initialize();

module.exports = OtherAddressesHelper;



// WEBPACK FOOTER //
// ./Javascript/accountComponents/OtherAddressesHelper.jsx